import React, { Fragment } from 'react'
import Pdf from 'views/employer/employerComponents/Pdf'
import ApplicantCandidateProfile from './ApplicantCandidateProfile'

const ApplicantRightContainer = ({
    glow, categoryChangingGlow,
    candidateData
}) => {

    return (
        <Fragment>
            {glow || categoryChangingGlow ?
                <div className="card h-100 border-0">
                    <div className="card-body h-100 overflow-scroll p-lg-4 px-lg-2 row">
                        <div className="col-12">
                            <div className="container-fluid">
                                <div className="row border-bottom border-3 py-3">
                                    <div className="col-2 text-center">
                                        <img
                                            src={""}
                                            alt="..."
                                            width={100}
                                            height={100}
                                            className="pe-none placeholder rounded-circle"
                                        />
                                    </div>

                                    <div className="col-10">
                                        <div className="row">
                                            <div className="col-lg-6 col-xxl-8">
                                                <h1 className="employer-card-candidate-name mb-0 d-inline-block pe-3 border-end border-dark placeholder w-50 py-3 rounded-1 me-2"></h1>
                                                <h1 className="employer-card-candidate-role mb-0 d-inline-block ps-3 placeholder w-25 py-3 rounded-1"></h1>
                                            </div>
                                            <div className="col-lg-6 col-xxl-4">
                                                <button
                                                    type="button"
                                                    className="btn btn-sm px-5 border py-2 me-1 placeholder"
                                                ></button>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm px-5 border py-2 placeholder"
                                                ></button>
                                            </div>
                                            <div className="col-12 pt-4 row">
                                                <div className="col-5">
                                                    <p className="employer-card-candidate-role placeholder pt-3 pb-2 w-100 rounded-1"></p>
                                                </div>
                                                <div className="col-4">
                                                    <p className="employer-card-candidate-role placeholder pt-3 pb-2 w-75 rounded-1"></p>
                                                </div>
                                                <div className="col-3">
                                                    <p className="employer-card-candidate-role placeholder pt-3 pb-2 w-75 rounded-1"></p>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <button
                                                    button="button"
                                                    className="btn col-2 me-4 py-1 placeholder"
                                                ></button>
                                                <button
                                                    button="button"
                                                    className="btn col-1 py-1 placeholder"
                                                ></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 border-bottom border-3 py-4">
                                    <ApplicantCandidateProfile
                                        glow={glow || categoryChangingGlow} 
                                        candidateData={candidateData}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                :
                <div className="col-12 p-3">
                    <div className="container-fluid">
                        <div className="d-flex flex-wrap border-bottom border-3 py-5">
                            <div className="col-12 col-sm-3 col-xl-2 text-center">
                                <img
                                    src={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${candidateData?.profile_image}`}
                                    alt=""
                                    width={100}
                                    height={100}
                                    className="rounded-circle"
                                />
                            </div>

                            <div className="col-12 col-sm-9 col-xl-10 pt-4 pt-sm-0 ">
                                <div className="d-flex flex-wrap align-items-center">
                                    <div className={window.location.pathname === "/employer_dashboard/candidates/full_details" ? "col-12 col-md-6 col-xxl-8 d-flex flex-wrap align-items-center text-center text-md-start" : "col-lg-12 col-xl-8 d-flex flex-wrap align-items-center"} >
                                        <h1 className="employer-card-candidate-name mb-0 d-inline-block pe-3 ">
                                            <span className="border-end border-dark pe-3">
                                                {candidateData?.first_name}{" "}
                                                {candidateData?.last_name}
                                            </span>

                                            <span className="employer-card-candidate-role mb-0 d-inline-block ps-3 ">
                                                {candidateData?.job_title}
                                            </span>
                                        </h1>
                                    </div>
                                    <div className="col-12 col-sm-8 col-md-12 pt-4 d-flex flex-wrap">
                                        <div className={window.location.pathname === "/employer_dashboard/candidates/full_details" ? "col-12 col-md-8 col-lg-5" : "col-12 col-md-8 col-lg-12 col-xl-5"}>
                                            <p className="employer-card-candidate-role ">
                                                <strong className="pe-2">Email :</strong>
                                                <span>{candidateData?.email_id}</span>
                                            </p>
                                        </div>
                                        <div className={window.location.pathname === "/employer_dashboard/candidates/full_details" ? "col-12 col-md-8 col-lg-5" : "col-12 col-md-8 col-lg-12 col-xl-4"}>
                                            <p className="employer-card-candidate-role">
                                                <strong className="pe-2">Location :</strong>
                                                <span>{candidateData?.city}</span>
                                            </p>
                                        </div>
                                        <div className={window.location.pathname === "/employer_dashboard/candidates/full_details" ? "col-12 col-md-8 col-lg-5" : "col-12 col-md-8 col-lg-12 col-xl-3"}>
                                            <p className="employer-card-candidate-role">
                                                <strong className="pe-2">Phone :</strong>
                                                {candidateData?.contact_number}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 border-bottom border-3 py-4">
                        <ApplicantCandidateProfile
                            glow={glow || categoryChangingGlow} 
                            candidateData={candidateData}
                        />
                    </div>

                    {
                        candidateData?.resume_name !== "professional/resume/" && !glow && !categoryChangingGlow ?
                            <div className="col-12 pt-5">
                                <div className="container-fluid">
                                    <div className="row align-items-center">
                                        <div className="col-6">
                                            <h1 className="employer-card-Content-heading">Resume</h1>
                                        </div>
                                        <div className="col-6 text-end">
                                            <button id="applicantsDownloadResumeButton" type="button" className="btn btn-transparent border btn-brand-color candidate-right-side-btn">
                                                <a href={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${candidateData?.resume_name}`} className="text-light text-decoration-none" download>Download</a>
                                            </button>
                                        </div>
                                    </div>
                                    <Pdf pdfUrl={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${candidateData?.resume_name}`} />
                                </div>
                            </div>
                            :
                            null
                    }


                    {
                        candidateData?.cover_letter_name !== "professional/cover-letter/" && !glow && !categoryChangingGlow ?
                            <div className="col-12 pt-5">
                                <div className="container-fluid">
                                    <div className="row align-items-center">
                                        <div className="col-6">
                                            <h1 className="employer-card-Content-heading">Cover letter</h1>
                                        </div>
                                        <div className="col-6 text-end">
                                            <button id="applicantsDownloadCoverLetterButton" type="button" className="btn btn-transparent border btn-brand-color candidate-right-side-btn">
                                                <a href={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${candidateData.cover_letter_name}`} className="text-light text-decoration-none" download>Download</a>
                                            </button>
                                        </div>
                                    </div>
                                    <Pdf
                                        pdfUrl={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${candidateData.cover_letter_name}`}
                                    />
                                </div>
                            </div>
                            :
                            null
                    }

                    {
                        candidateData?.question_answers?.length ?
                            <div className="col-12 pt-5">
                                <div className="container">
                                    <h1 className="employer-card-Content-heading">
                                        Additional Questions
                                    </h1>

                                    {candidateData?.question_answers.map((v, i) => {
                                        return (
                                            <div className="col-12" key={i}>
                                                <p className="employer-card-Content">
                                                    <span className="pe-2">{i + 1}.</span>
                                                    {v?.custom_pre_screen_ques}
                                                </p>
                                                <div className="px-4">
                                                    <textarea
                                                        className="p-3 rounded-3 mb-3 form-control outline-none pe-none employer-card-Content"
                                                        minLength={25}
                                                        maxLength={10000}
                                                        rows={4}
                                                        value={v?.custom_pre_screen_ans}
                                                    />
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                            :
                            null
                    }
                </div>
            }
        </Fragment>
    )
}

export default ApplicantRightContainer